import authSliceReducer from "./Slices/AuthSlice";
import connectedDeviceReducer from "./Slices/ConnectedDeviceSlice";
import installedGadgetReducer from "./Slices/InstalledGadgetsSlice";
import notificationReducer from "./Slices/NotificationSlice";
import headerMenuReducer from "./Slices/HeaderMenuSlice";
import installOnAllDeviceReducer from "./Slices/InstallOnAllDeviceSlice";
import { configureStore } from '@reduxjs/toolkit';

export const store = configureStore({
    reducer: {
        auth: authSliceReducer,
        connectedDeviceSlice: connectedDeviceReducer,
        installedGadgetSlice: installedGadgetReducer,
        notificationSlice: notificationReducer,
        installOnAllDeviceSlice: installOnAllDeviceReducer,
        headerMenuSlice: headerMenuReducer
    },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;